export const NAME_SET = 'checkout.NAME_SET';
export const SURNAME_SET = 'checkout.SURNAME_SET';
export const EMAIL_SET = 'checkout.EMAIL_SET';
export const PHONE_SET = 'checkout.PHONE_SET';
export const CARD_COMPLETE_SET = 'checkout.CARD_COMPLETE_SET';

export const LINK_SET = 'checkout.LINK_SET';